module.exports = __webpack_public_path__ + "img/Queima de ramos podados.25431140.webp";